import SectionMessage from '@atlaskit/section-message';
import { ModalTransition } from '@atlaskit/modal-dialog';

import React from 'react';
import { FormattedMessage } from 'react-intl';

import config from 'appconfig';
import { messages } from 'modules/mac/messages';
import Link from 'components/common/Link';
import t from 'modules/i18n/intl';

import { PromotionContent } from './PromotionContent';

const link = (chunks) => <Link to={config.companyContact}>{chunks}</Link>;

export const MakePrimaryModal = ({
  closeModal,
  accountId,
  contactRelationshipType,
  email,
  handlePromotion,
  promotionError,
  mainEmail,
}) => (
  <ModalTransition>
    <PromotionContent
      kind={contactRelationshipType}
      currentMainEmail={mainEmail}
      currentEmail={email}
      accountId={accountId}
      onCancel={closeModal}
      onConfirm={handlePromotion}
      extraMessage={
        <>
          {promotionError === 'irreconcilable' && (
            <SectionMessage appearance="error">
              {t(messages.promotionIrreconcilable, { link })}
            </SectionMessage>
          )}
          {promotionError === 'failed' && (
            <SectionMessage appearance="error">
              <FormattedMessage {...messages.promotionFailed} />
            </SectionMessage>
          )}
        </>
      }
    />
  </ModalTransition>
);
